import { getMyMediaFiles } from "../services/galleryThunks";
const myGalleryMediaFilesSource = {
    selectState: (state) => state.myGallery,
    fetchFiles: getMyMediaFiles,
};
export default myGalleryMediaFilesSource;
